module.exports = __webpack_public_path__ + "static/media/bbc_news_uk-politics-eu-referendum-36420148_plot.066c859d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_uk-politics-eu-referendum-36420148_plot.png
// module id = 359
// module chunks = 0